// extracted by mini-css-extract-plugin
module.exports = {"fractional-quantity":"FractionalQuantity__fractional-quantity___3F3v1"};